var _defs, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAllBrands(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 51.09 51.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ffa586;\n      }\n\n      .cls-2 {\n        fill: #de675d;\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient);\n        stroke: url(#linear-gradient-2);\n        stroke-miterlimit: 10;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 26.22,
    y1: 132.39,
    x2: 26.22,
    y2: 79.8,
    gradientTransform: "translate(0 132.89) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#493842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38192d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1.34,
    y1: 24.88,
    x2: 51.09,
    y2: 24.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffa586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b51a2b"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M48.75,27.03c0,13.46-10.91,24.38-24.38,24.38S0,40.49,0,27.03,10.91,2.65,24.38,2.65s24.38,10.91,24.38,24.38Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M50.59,24.88c0,13.46-10.91,24.38-24.37,24.38S1.84,38.34,1.84,24.88,12.76.5,26.22.5s24.37,10.91,24.37,24.38Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.02,21.55l-2.31-4.53c-.24-.46-.9-.45-1.12.02l-2.16,4.52c-.16.3-.52.57-.83.62l-4.74.7c-.49.07-.71.66-.38,1.03l3.38,3.82c.23.22.36.67.31,1l-.8,5c-.08.5.44.88.89.66l4.46-2.23c.29-.16.73-.16,1.01,0l4.46,2.23c.46.23.98-.15.9-.66l-.8-5c-.05-.32.08-.78.31-1l3.38-3.82c.33-.37.11-.96-.38-1.03l-4.74-.7c-.31-.05-.7-.32-.83-.62Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllBrands);
export default __webpack_public_path__ + "static/media/AllBrands.90a803c2917aa274acbb5c06ac72c8c8.svg";
export { ForwardRef as ReactComponent };